import React from "react";
import { Button, ButtonGroup, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Views } from "react-big-calendar";

const ReactCalendarToolbar = ({ label, onNavigate, onView, view }) => {
  const { t } = useTranslation("global");

  return (
    <Row className="align-items-center mb-3">
      <Col xs={12} md={6}>
        <h5 className="mb-0">{label}</h5>
      </Col>
      <Col xs={12} md={6} className="text-md-end mt-2 mt-md-0">
        <ButtonGroup className="me-2">
          <Button
          className="btn-nxt-pre"
            // variant={view === Views.MONTH ? "btn-nxt-pre" : "btn-nxt-pre"}
            onClick={() => onView(Views.MONTH)}
          >
            {t("calendar.month")}
          </Button>
          <Button
          className="btn-nxt-pre"

            // variant={view === Views.WEEK ? "btn-nxt-pre" : "btn-nxt-pre"}
            onClick={() => onView(Views.WEEK)}
          >
            {t("calendar.week")}
          </Button>
          <Button
            // variant={view === Views.AGENDA ? "btn-nxt-pre" : "btn-nxt-pre"}
          className="btn-nxt-pre"

            onClick={() => onView(Views.AGENDA)}
          >
            {t("calendar.year")}
          </Button>
        </ButtonGroup>
        <ButtonGroup>
          <Button className="btn-nxt-pre" onClick={() => onNavigate("PREV")}>
            {t("calendar.prev")}
          </Button>
          <Button className="btn-nxt-pre" onClick={() => onNavigate("NEXT")}>
            {t("calendar.next")}
          </Button>
        </ButtonGroup>
      </Col>
    </Row>
  );
};

export default ReactCalendarToolbar;